import { render, staticRenderFns } from "./OverDue.vue?vue&type=template&id=1d9ca940&scoped=true"
import script from "./OverDue.vue?vue&type=script&lang=js"
export * from "./OverDue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9ca940",
  null
  
)

export default component.exports